// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mv-1";
export var messageSideRight = "_mv-2";
export var orderLookupBubbleContainer = "_mv-0";
export var submitButton = "_mv-3";